"use client"
import { usePathname } from "next/navigation"
import type { ReactNode } from "react"
import styles from "./mobile-reservation.module.css"

export function isReservationWizard(path: string) { return /\/reserve(?:\/(?:trip|vehicles|details|review))?\/?$/.test(path) }
export function ReservationChrome({ children }: { children: ReactNode }) {
  const path = usePathname()
  return <div className={styles.reservation} data-wizard={isReservationWizard(path)}>{children}</div>
}
